const getDefaultState = () => {
  return {
    selected: {},
    order: {},
  };
};

const state = getDefaultState();

const mutations = {
  SET_SELECTED(state, payload) {
    state.selected = Object.assign(state.selected, payload);
  },
  CLEAR_SELECTED(state) {
    state.selected = {};
  },

  SET_ORDER(state, payload) {
    state.order = Object.assign(state.order, payload);
  },
  CLEAR_ORDER(state) {
    state.order = {};
  },
  CLEAR_REORDER() {
    state.reOrder
  },
  SET_TEMPLATES(state, payload) {
    state.templates = Object.assign(state.templates, payload);
  },
  CLEAR_TEMPLATES(state) {
    state.templates = {};
  },
};

const actions = {
  clearSession({ commit }) {
    commit("CLEAR_ORDER");
    commit("CLEAR_SELECTED");
    localStorage.setItem("personal_address",JSON.stringify([]));
  },
  clearOrderInfo({ commit }){
    commit("CLEAR_ORDER");
  },
  clearSessionTemplate({ commit }) {
    commit("CLEAR_TEMPLATES");
  },
  clearSessionReOrder({ commit }) {
    commit("CLEAR_REORDER");
  }
};

export default {
  state,
  mutations,
  actions,
};
